import React, {useEffect, useState} from 'react'
import { useLocation } from 'react-router-dom';
import './TestActivity.css'
import axios from 'axios';
import { fadeIn } from 'react-animations'
import styled, { keyframes } from 'styled-components';
import { WaitView } from '../testactivity/WaitView';
import { TestCompletion } from '../testactivity/TestCompletion';
import Unauthorized from '../testactivity/Unauthorized';
import { Test } from './Test';

import { Introduction } from './Introduction';
import Behaviours from './Behaviours';
import Instructions from './Instructions';

const TestActivity = () => {
    const query = new URLSearchParams(useLocation().search);
    const token = query.get("token");

  const [heading, setHeading] = useState("Introduction");
  const [page, setPage] = useState(0);
  const [pageState, setPageState] = useState("ui");
  const [behavioursState, setBehavioursState] = useState(false);
  const [behavioursData, setBehavioursData] = useState({
            status: "",
            data: [],
            total: 0
        });
  const [status, setStatus] = useState("pending");
  const[logo, setLogo] = useState();
  const[name, setName] = useState("User");
  const[days, setDays] = useState(0);
  const [authentication, setAuthentication] = useState("checking");

  useEffect(()=>{
    if(authentication == "checking"){
        axios.get('/assessment/status?id=' + token)
        .then(function (response) {
            setAuthentication(response.data.status);
            setName(response.data.name);
            setLogo(response.data.logo);
            setDays(response.data.days);
        })
        .catch(function (error) {
            setStatus("");
        });
    }

    if(behavioursState == false){
        axios.get('/assessment/clusters')
          .then(function (response) {
            if(response.data.status == "success"){
              setBehavioursData(response.data);
              setBehavioursState(true);
            }
            else{
              //setErrors(response.data.message);
            }
          })
          .catch(function (error) {
            //setErrors(error.message);
          });
      }
  })

  const goToPage=(pageNumber)=>{
    setPage(pageNumber);
    switch (pageNumber) {
        case 1:
            setHeading("High Performance Behaviour framework for leaders");
            setPageState("ui");
            break;
        case 2:
            setHeading("Instructions");
            setPageState("ui");
            break;
        case 3:
            setHeading("Situations");
            setPageState("test");
            break;
        default:
            setHeading("Introduction");
            setPageState("ui");
            break;
    }
  }

  const handleNext=()=>{
    if(page < 2){
        goToPage(page + 1);
        setPageState("ui");
    }
    else{
        setHeading("Situations");
        startTest();
    }
  }

  const handlePrevious=()=>{
    if(page > 0){
        goToPage(page - 1);
        setPageState("ui");
    }
  }

  const startTest=()=>{
    axios.get('/assessment/start?id=' + token)
    .then(function (response) {
        setStatus(response.data.status);
        if(response.data.status == "" || response.data.status == "started" ){
            setPageState("test");
            setPage(3);
        }
    })
    .catch(function (error) {
      console.error(error);
    });
  }

  /* animations */
  const a1 = keyframes`${fadeIn}`;
    const AnimateContent = styled.div`animation: 2s ${a1};`;

  return (
    <div className="test">
        { authentication == "checking" && 
            <div>
                <WaitView/>
            </div>
        }
        { authentication == "stopped" &&
            <TestCompletion/>
        }
        { authentication == "unauthorized" &&
            <Unauthorized/>
        }

        { (authentication == "" || authentication == "started") &&
        
        <div className="assessment">
            <header className="navbar sticky-top bg-light flex-md-nowrap shadow">
            <a className="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6" href="#">
                <img src={axios.defaults.baseURL + '/' + logo} alt={name} className="img-responsive logo" />
            </a>
            <div className="w-100" ><h2 className="headingview">{heading}</h2></div>
            </header>
            <div className="container-fluid">
            <div className="row">
                <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
                <div className="position-sticky pt-3 sidebar-sticky">
                    <ul className="nav flex-column">
                    <li className="nav-item" onClick={()=>goToPage(0)}>
                        <a className={page == 0 ? "nav-link active" : "nav-link"} aria-current="page" href="#">
                        <span data-feather="home" className="align-text-bottom"></span>
                        Introduction
                        </a>
                    </li>
                    { behavioursState == true && 
                        <li className="nav-item" onClick={()=>goToPage(1)}>
                            <a className={page == 1 ? "nav-link active" : "nav-link"} href="#">
                            <span data-feather="file" className="align-text-bottom"></span>
                            Behaviours
                            </a>
                        </li>
                    }
                    <li className="nav-item" onClick={()=>goToPage(2)}>
                        <a className={page == 2 ? "nav-link active" : "nav-link"} href="#">
                        <span data-feather="shopping-cart" className="align-text-bottom"></span>
                        Instructions
                        </a>
                    </li>
                    { pageState == "test" && 
                    <li className="nav-item" onClick={()=>goToPage(3)}>
                        <a className={page == 3 ? "nav-link active" : "nav-link"} href="#">
                        <span data-feather="users" className="align-text-bottom"></span>
                        Situations
                        </a>
                    </li>
                }
                    </ul>

                    <div className="branding">
                        <span className="brand-name">Leadership Behaviour Assessment</span>
                        <span>Power by A.I.</span>
                        <img className="brand-logo" title="InspireOne" src="images/Logo.png"/>
                    </div>
                </div>
                </nav>

                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">

                { page == 0 && <Introduction name={name}/> }

                { (page == 1 && behavioursData.data.length > 0) && <Behaviours rows={behavioursData.data} /> }

                { page == 2 && <Instructions /> }

                { page == 3 &&  <Test token={token} days={days}/> }
                    
                </div>
                { pageState == "ui" ? <div className="btn-group btn-group-justified">
                    { page > 0 ? <button className="btn btn-secondary" onClick={handlePrevious}>Back</button> : ""}
                    <button className="btn btn-primary" onClick={handleNext}>Continue</button>
                </div> 
                    : ""}
                </main>
            </div>
            </div>
        </div>
        
        }
        </div>
  )
}

export default TestActivity